<nav>
  <a routerLink="/home">Home</a>
  |
  <a routerLink="/admin">Admin</a>
</nav>
<router-outlet></router-outlet>